module.exports = __webpack_public_path__ + "static/img/huahanghanya.29cab62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/huahanghanya.png
// module id = 08Sa
// module chunks = 44